import React, { useContext } from 'react';

import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import RestaurantProducts from './RestaurantProducts';
import GroceryProducts from './GroceryProducts';
import WholesaleProduct from './WholesaleProduct';
import { Error404 } from '../error404/Error404';
import { API_NETWORK_ERROR } from '../../utils/constants';

const AddProduct = () => {
  const { OnLoadInformation, onLoadInfoResponse, setisLoggedIn } =
    useContext(GlobalStateDataContext);
  const { data, loading, message, success } = onLoadInfoResponse;
  const AccountType = data?.data?.data?.KitchenInfo?.account_type;
  const RestaurantTypes = [
    'cloud kitchen',
    'restaurant',
    'home chef',
    'catering',
    'celebrity chef',
    'promotional kitchen',
  ];

  if (success === false && message === API_NETWORK_ERROR) {
    return <Error404 />;
  }

  if (RestaurantTypes?.includes(AccountType)) {
    return <RestaurantProducts />;
  }

  if (AccountType === 'grocery store') {
    return <GroceryProducts />;
  }

  if (AccountType === 'wholesale store') {
    return <WholesaleProduct />;
  }
};

export default AddProduct;
